module.exports = __webpack_public_path__ + "static/media/1-Y.728b8f83.mp3";